import CustomizeLoader from './CustomizeLoader'

export default CustomizeLoader
